import NNavbar from './navbar.jsx';
import Footer from './footer';
import Callback from './callback';
import '../styles/services.css';
import serviceBg from "../media/services/service_landing.jpg"; 
import vat from '../media/services/vat.jpg';
import payroll from '../media/services/payroll.jpg';
import accountingbookkeeping from '../media/services/accountingbookkeeping.jpg';
import dataanalytics from '../media/services/dataanalytics.jpg';
import internalaudit from '../media/services/internalaudit.jpg';
import cfo from '../media/services/cfo.jpg';
import auditliaison from '../media/services/auditliason.jpg';
import amlcompliance from '../media/services/amlcompliance.jpg';
import { useState, useEffect } from 'react';
import { Container, Button } from "react-bootstrap";

const cardData = [
  {
    title: "VAT & Corporate Tax Compliance",
    desc: "Eliminate the stress of taxation with complete support across VAT and corporate tax compliance, planning and reporting.",
    link: "/service/vatandcorporatetax",
    image: vat,
  },
  {
    title: "Payroll Management",
    desc: "Let us handle your payroll needs while you focus on building your team and growing your business.",
    link: "/service/payroll",
    image: payroll,
  },
  {
    title: "Accounting & Bookkeeping Services",
    desc: "Stay organized, transparent, and compliant with our meticulous accounting solutions tailored to your business type and industry.",
    link: "/service/accountingandbookkeeping",
    image: accountingbookkeeping,
  },
  {
    title: "Data Analytics & Business Intelligence",
    desc: "Make smarter decisions with insights powered by data, not guesswork.",
    link: "/service/dataanalyticsandbi",
    image: dataanalytics,
  },
  {
    title: "Internal Audit Services",
    desc: "Build stronger internal systems and reduce risk with targeted audit solutions tailored to your operations.",
    link: "/service/internalaudit",
    image: internalaudit,
  },
  {
    title: "CFO Support Services",
    desc: "Access executive-level financial insight—without hiring a full-time CFO.",
    link: "/service/cfosupport",
    image: cfo,
  },
  {
    title: "Audit Liaison & Final Reports",
    desc: "Stay calm and compliant when audit season arrives—we’ve got your back.",
    image: auditliaison,
  },
  {
    title: "AML & Compliance Services",
    desc: "Operate with integrity and confidence in a heavily regulated business environment.",
    link: "/service/amlcompliance",
    image: amlcompliance,
  },
];

function Services() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % cardData.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? cardData.length - 1 : prevIndex - 1
    );
  };

  // Auto slide every 2 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % cardData.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <NNavbar />
      <section className="services-section">
        {/* Hero Section */}
        <div
          className="services-hero d-flex align-items-center"
          style={{ backgroundImage: `url(${serviceBg})` }}
        >
          <Container>
            <div className="hero-text text-md-end text-center">
              <center>
                <h2>
                  Our <span className="highlight">Services</span>
                </h2>
                <p>
                  We offer a full suite of financial, compliance and strategic services tailored to meet the evolving needs of businesses across the UAE and beyond. Whether you're a startup looking for foundational support or an established company seeking optimization, our services are designed to grow with you ensuring precision, compliance and clarity at every step.
                </p>
              </center>
            </div>
          </Container>
        </div>

        {/* Carousel Section */}
        <Container className="py-5 d-flex flex-column align-items-center">
          <div className="carousel-wrapper">
            <Button className="nav-arrow left" onClick={prevSlide}>
              &#8592;
            </Button>

            <div className="carousel-card" onClick={() => window.location.href=cardData[currentIndex].link}>
              <img src={cardData[currentIndex].image} alt="icon" />
              <div className="carousel-content">
                <h5>{cardData[currentIndex].title}</h5>
                <p>{cardData[currentIndex].desc}</p>
              </div>
            </div>

            <Button className="nav-arrow right" onClick={nextSlide}>
              &#8594;
            </Button>
          </div>

          {/* Carousel Dots */}
          <div className="carousel-dots mt-3">
            {cardData.map((_, index) => (
              <span
                key={index}
                className={`dot ${index === currentIndex ? 'active' : ''}`}
                onClick={() => setCurrentIndex(index)}
              ></span>
            ))}
          </div>
        </Container>
      </section>
      <Callback />
      <Footer />
    </>
  );
}

export default Services;
